module.exports = __webpack_public_path__ + "img/tune1-radio.4ab80bf1.png";